


import {Vue, Component} from 'vue-property-decorator';
import {Getter} from 'vuex-class';
import ChatHelper from '@/_modules/chat/helpers/chat.helper';
import {TEvent} from '@/_types/event.type';

const CUSTOM_EVENT_ID = process.env.VUE_APP_ENV === 'development' ? 548 : 543;

@Component
export default class SectionAboutEvent extends Vue {

  @Getter('_eventStore/event') event: TEvent;

  public get isCustomEvent(): boolean {
    const eventId = this.$route.params.eventId ? parseInt(this.$route.params.eventId, 10) : null;
    return eventId === CUSTOM_EVENT_ID;
  }

  public get customAboutEventTitle(): string {
    const dict: {[key: string]: string} = {
      ru: 'О конференц центре',
      en: 'About conference centre',
      zh: '关于会议中心',
    };
    if (Object.hasOwnProperty.call(dict, this.$i18n.locale)) {
      return dict[this.$i18n.locale];
    }
    return dict.en;
  }

  public get preparedAgenda(): string[] {
    if (this.event && this.event.agendas) {
      return this.event.agendas.split(/(\r\n|\r|\n)/).filter(x => x);
    }
    return [];
  }

  public get preparedEventDescription(): string {
    if (!this.event || !this.event.descr) {
      return '';
    }
    return this.linkifyUrls(this.event.descr);
  }

  public get isSectionVisible(): boolean {
    return this.preparedAgenda.length > 0
      || !!this.preparedEventDescription;
  }

  public linkifyUrls(input: string): string {
    return ChatHelper.createLinks(input);
  }
}
